import {animate, style, transition, trigger} from "@angular/animations"

export const fadeInCardAnimation = trigger("fadeInCard", [transition("void => *", [style({opacity: 0.6}), animate("200ms", style({opacity: 1}))])])
